import axios from 'axios';
import { calcScorePercValues } from '../calcScorePercValues';
import { IDragon } from "../../helpers/interfaces/dragon"

export type GetDragonsResponse = {
    status: number,
    nftList?: IDragon[],
    error?: APIError
}

export type APIError = {
    code: number,
    msg: string
}

//
export async function getDragonsData(address: string | null): Promise<GetDragonsResponse> {

    try {
        let url = `${process.env.NEXT_PUBLIC_API_URL}/dragons/${address}`;
        let res = await axios.get(url);

        if (res.status >= 0) {
            for (let i = 0; i < res.data.length; i++) {
                let dragon = res.data[i];

                // Set reveal countdown!
                dragon.revealWaitDate = dragon.revealCountdownMs === 0 ? Date.now() : new Date(Date.now() + dragon.revealCountdownMs + 1000);

                if (dragon.score) {
                    calcScorePercValues(dragon.score);
                }
            }

            return {
                status: 0,
                nftList: res.data
            };
        } else {
            return { status: -1, error: { code: -5, msg: "error" } }
        }
    } catch (error: any) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Error', error.response.data);
            console.error('Error', error.response.status);
            console.error('Error', error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error', error.message);
        }

        console.error('Error', error.config);

        return { status: -1, error: { code: -5, msg: "error" } }
    };

}
